import "./WorkshopSection.css";
import eventData from './data/event-details.json';
import eventForms from './data/event-forms.json';
import { useAuth } from './AuthContext';
import styled from 'styled-components';

const StyledCard = styled.div`
  .card {
    --background: linear-gradient(135deg, #00f0ff 0%, #7f5bff 100%);
    width: 100%;
    height: 500px;
    padding: 5px;
    border-radius: 1rem;
    overflow: visible;
    background: var(--background);
    position: relative;
    z-index: 1;
  }

  .card::after {
    position: absolute;
    content: "";
    top: 30px;
    left: 0;
    right: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
    transform: scale(0.8);
    filter: blur(25px);
    background: var(--background);
    transition: opacity .5s;
  }

  .card-info {
    --color: #0a0a0a;
    background: var(--color);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: .7rem;
    padding: 30px 25px;
    text-align: center;
  }

  .card:hover::after {
    opacity: 0;
  }

  .card:hover .card-info {
    background: rgba(10, 10, 10, 0.95);
    transition: all 0.5s;
  }

  .speaker-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #4fdcff;
    margin-bottom: 15px;
    box-shadow: 0 0 20px rgba(79, 220, 255, 0.4);
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .speaker-image:hover {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(79, 220, 255, 0.6);
  }

  .linkedin-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #0077b5;
    text-decoration: none;
    font-size: 0.9rem;
    margin-top: 10px;
    padding: 6px 12px;
    border-radius: 20px;
    background: rgba(0, 119, 181, 0.1);
    transition: all 0.3s ease;
  }

  .linkedin-link:hover {
    background: rgba(0, 119, 181, 0.2);
    transform: translateY(-2px);
  }

  .linkedin-link i {
    font-size: 1.1rem;
  }

  .blog-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #ff6b35;
    text-decoration: none;
    font-size: 0.9rem;
    margin-top: 10px;
    padding: 6px 12px;
    border-radius: 20px;
    background: rgba(255, 107, 53, 0.1);
    transition: all 0.3s ease;
  }

  .blog-link:hover {
    background: rgba(255, 107, 53, 0.2);
    transform: translateY(-2px);
  }

  .blog-link i {
    font-size: 1.1rem;
  }

  .workshop-icon {
    font-size: 3rem;
    color: #4fdcff;
    margin-bottom: 15px;
  }

  .workshop-title {
    font-family: 'Orbitron', monospace;
    font-size: 1.05rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 10px;
    letter-spacing: 0.5px;
    line-height: 1.3;
  }

  .workshop-oneliner {
    font-family: 'Inter', sans-serif;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.4;
    margin-bottom: 15px;
    font-style: italic;
  }

  .workshop-details {
    width: 100%;
    padding-top: 15px;
    border-top: 1px solid rgba(79, 220, 255, 0.2);
  }

  .workshop-details p {
    font-family: 'Inter', sans-serif;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.75);
    margin: 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .speaker-name {
    font-weight: 600;
    color: #4fdcff !important;
    font-size: 0.95rem !important;
  }

  .designation {
    font-size: 0.8rem !important;
    color: rgba(255, 255, 255, 0.65) !important;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 2.8em;
  }

  .schedule {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  @media (max-width: 768px) {
    .card {
      height: 480px;
    }

    .card-info {
      padding: 25px 20px;
    }

    .speaker-image {
      width: 100px;
      height: 100px;
    }

    .workshop-title {
      font-size: 1rem;
    }

    .workshop-oneliner {
      font-size: 0.8rem;
    }

    .workshop-details p {
      font-size: 0.8rem;
    }

    .linkedin-link {
      font-size: 0.85rem;
    }

    .blog-link {
      font-size: 0.85rem;
    }
  }

  @media (max-width: 480px) {
    .card {
      height: 450px;
    }

    .card-info {
      padding: 20px 15px;
    }

    .speaker-image {
      width: 90px;
      height: 90px;
      margin-bottom: 12px;
    }

    .workshop-title {
      font-size: 0.95rem;
      margin-bottom: 8px;
    }

    .workshop-oneliner {
      font-size: 0.75rem;
      margin-bottom: 12px;
    }

    .workshop-details {
      padding-top: 12px;
    }

    .workshop-details p {
      font-size: 0.75rem;
      margin: 6px 0;
    }

    .speaker-name {
      font-size: 0.85rem !important;
    }

    .designation {
      font-size: 0.7rem !important;
    }

    .linkedin-link {
      font-size: 0.8rem;
      padding: 5px 10px;
    }

    .blog-link {
      font-size: 0.8rem;
      padding: 5px 10px;
    }
  }
`;

export default function WorkshopSection() {
  const { user } = useAuth();
  const workshopsData = eventData.workshops;

  const workshops = [
    {
      ...workshopsData["Gen AI Workshop: From Prompts to Prototypes"],
      title: "Gen AI Workshop: From Prompts to Prototypes",
      icon: "fas fa-brain",
      speakerImage: "/speaker/1.jpeg"
    },
    {
      ...workshopsData["Explore Full Stack: The Ultimate Hands-on Workshop"],
      title: "Explore Full Stack: The Ultimate Hands-on Workshop",
      icon: "fas fa-layer-group",
      speakerImage: "/speaker/2.jpeg"
    },
    {
      ...workshopsData["Emerging Cyber Threats: Attacks, Trends, and Defense Strategies"],
      title: "Emerging Cyber Threats: Attacks, Trends, and Defense Strategies",
      icon: "fas fa-shield-alt",
      speakerImage: "/speaker/3.jpeg"
    },
    {
      ...workshopsData["LLM and Agentic AI: Intelligent Models, Autonomy, and Future Innovations"],
      title: "LLM and Agentic AI: Intelligent Models, Autonomy, and Future Innovations",
      icon: "fas fa-robot",
      speakerImage: "/speaker/4.jpeg"
    }
  ];

  return (
    <section className="workshop-container">
      <h2 className="section-title">Workshops</h2>

      <div className="workshop-hero">
        <h3 className="hero-tagline">Learn. Build. Innovate.</h3>
        <p className="hero-description">
          Join our expert-led workshops and gain hands-on experience with cutting-edge technologies
        </p>
      </div>

      <div className="workshops-grid">
        {workshops.map((workshop, index) => (
          <StyledCard key={index}>
            <div className="card">
              <div className="card-info">
                <div>
                  <img src={workshop.speakerImage} alt={workshop.speaker} className="speaker-image" />
                  <h4 className="workshop-title">{workshop.title}</h4>
                  <p className="workshop-oneliner">{workshop.oneLiner}</p>
                </div>
                <div className="workshop-details">
                  <p className="speaker-name"><i className="fas fa-user"></i> {workshop.speaker}</p>
                  <p className="designation">{workshop.designation}</p>
                  <p className="schedule"><i className="far fa-calendar"></i> {workshop.date}</p>
                  <p className="schedule"><i className="far fa-clock"></i> {workshop.time}</p>
                  {workshop.linkedin ? (
                    <a 
                      href={workshop.linkedin} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="linkedin-link"
                    >
                      <i className="fab fa-linkedin"></i> Connect
                    </a>
                  ) : workshop.link ? (
                    <a 
                      href={workshop.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="blog-link"
                    >
                      <i className="fas fa-blog"></i> Visit Blog
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </StyledCard>
        ))}
      </div>

      <div className="info-grid">
        <div className="info-card purple">
          <h3>Registration Fees</h3>
          <p>Single Workshop: ₹150</p>
          <p>Combo A (Any 2): ₹250</p>
          <p>Combo B (Any 3): ₹350</p>
          <p>Combo C (All 4): ₹450</p>
        </div>

        <div className="info-card blue">
          <h3>Event Schedule</h3>
          <p>Day 1: Jan 30 (Friday)</p>
          <p>Day 2: Jan 31 (Saturday)</p>
          <p>Duration: 2 hours each</p>
          <p>Mode: Offline</p>
        </div>

        <div className="info-card purple">
          <h3>What You'll Get</h3>
          <p>Expert-led training</p>
          <p>Certificate of participation</p>
          <p>Industry insights</p>
          <p>Hands-on experience</p>
        </div>
      </div>

      <div className="register-wrapper">
        <button 
          className="register-btn"
          onClick={() => {
            if (!user) {
              alert('Please login before registering for workshops');
              return;
            }
            window.open(eventForms.workshops.all, '_blank');
          }}
        >
          Register Now
        </button>
      </div>
    </section>
  );
}
